import { render, staticRenderFns } from "./app.mpx?vue&type=template&id=3ade6511&isApp"
import script from "./app.mpx?vue&type=script&lang=js&isApp"
export * from "./app.mpx?vue&type=script&lang=js&isApp"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports